import * as actionType from "../../constants";

const initialValues = {
  status: [],
  workflow: [],
  category: [],
  loading: false,
  board: false,
  message: "",
  statusType: "",
  modal: false,
  clearCategory: false,
  workflow_categories: [],
  code: "",
  status_board_details: {},
  user: [],
  newcategory: {},
};

export const statusworkflow = (state = initialValues, action) => {
  switch (action.type) {
    case actionType.STATUS_LOADING:
      return { ...state, loading: true, modal: false, board: false };
    case actionType.ALL_STATUS_LIST:
      return {
        ...state,
        status: action.payload,
        loading: false,
        board: false,
        modal: false,
      };
    case actionType.CREATE_STATUS:
      return {
        ...state,
        status: [...state.status, action.payload.status],
        board: true,
        message: action.payload.message,
        statusType: action.payload.statusType,
        modal: false,
        code: action.payload.code,
      };
    case actionType.UPDATE_STATUS:
      const allstatus = [...state.status];
      const updatedata = action.payload.status;
      const index = allstatus.findIndex((fin) => fin._id === updatedata._id);
      allstatus[index] = updatedata;
      return {
        ...state,
        status: allstatus,
        board: action.payload.board,
        message: action.payload.message,
        statusType: action.payload.statusType,
        modal: false,
        code: action.payload.code,
      };
    case actionType.STATUS_GET_ALL_CATEGORY:
      return {
        ...state,
        category: action.payload.cate,
        workflow_categories: action.payload.workflow_cate,
        board: action.payload.board,
        modal: false,
      };
    case actionType.STATUS_CREATE_NEW_CATEGORY:
      return {
        ...state,
        newcategory: action.payload.category,
        category: [...state.category, action.payload.category],
        statusType: action.payload.title,
        message: action.payload.message,
        modal: false,
        clearCategory: true,
      };
    case actionType.GET_ALL_WORKFLOW_LIST:
      return { ...state, workflow: action.payload, board: false, modal: false };
    case actionType.WORKFLOW_CLOSE_MODAL:
      return { ...state, board: false };
    case actionType.CREATE_WORKFLOW_STATUS:
      return {
        ...state,
        workflow: [...state.workflow, action.payload.createSingle],
        modal: false,
        board: action.payload.board,
        statusType: action.payload.title,
        message: action.payload.message,
        clearCategory: true,
        code: action.payload.code,
      };
    case actionType.UPDATE_WORKFLOW_SINGLE:
      const workid = action.payload.workid;
      const workflows = [...state.workflow];
      const findex = workflows.findIndex((wor) => wor.workflow_id === workid);
      workflows[findex] = action.payload.singleWork;
      return {
        ...state,
        workflow: workflows,
        message: action.payload.message,
        statusType: action.payload.title,
        board: action.payload.board,
        modal: false,
        clearCategory: true,
        code: action.payload.code,
      };
    case actionType.DEACTIVATE_STATUSWORKFLOW_MESSAGE:
      return {
        ...state,
        board: false,
        message: "",
        code: "",
        statusType: "",
      };
    case actionType.CREATE_SINGLE_WORKFLOW_ERROR:
      return {
        ...state,
        message: action.payload.message,
        statusType: action.payload.title,
        board: action.payload.board,
        modal: true,
        clearCategory: false,
        code: action.payload.code,
      };
    case actionType.DELETE_SINGLE_CATEGORY_WORKFLOW:
      const workidde = action.payload.workflow_id;
      const workflowall = [...state.workflow];
      const indexde = workflowall.findIndex(
        (it) => it.workflow_id === workidde
      );
      workflowall[indexde] = action.payload.deleCategory;
      return {
        ...state,
        workflow: workflowall,
        board: action.payload.board,
        actionType: action.payload.title,
        message: action.payload.message,
        modal: true,
      };
    case actionType.NULL_WORKFLOW_LIST:
      return { ...state, workflow: [] };
    case actionType.LINK_STATUS_CHECK_CATEGORY:
      return { ...state, board: false };
    case actionType.GET_BOARD_STATUS_DETAILS:
      return { ...state, status_board_details: action.payload };
    case actionType.GET_ALL_WORKFLOW_USER:
      const usersall = action.payload;
      const newuser = [];
      for (let iu in usersall) {
        newuser.push(usersall[iu]);
      }
      return {
        ...state,
        user: newuser,
      };

    default:
      return state;
  }
};
